import pckg from '../package.json';

export const DISPATCHER_VERSION = pckg.version;
